// extracted by mini-css-extract-plugin
module.exports = {"banner":"_shTKuTUG","bannerDark":"_bLvdZSdw","text":"_-p7dknbO","icon":"_0Afd_4h0"};